/* G Dash (#obsoldout): the add-to-cart button keeps ONE busy look from the click until the add has finished. A bundle
   app disables it while it adds its gifts, lets go for a moment, then the theme's cart disables it again: two fades, which
   read as the button jumping twice. While an add runs, the button holds its own disabled look (read from a hidden twin of it).
   Nothing else changes: the click, the cart requests and the button's own state stay the theme's and the app's. */
(function () {
  'use strict';
  if (window.__gdAtcHold) return;
  window.__gdAtcHold = true;
  var GRACE = 1200, AFTER = 150, CAP = 15000;
  var PROPS = ['opacity', 'color', 'background-color', 'border-color', 'box-shadow'];
  function busy(b) {
    return !!(b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('loading') ||
      b.classList.contains('is-busy'));
  }
  function look(b) {
    if (b.__gdAtcLook) return b.__gdAtcLook;
    var t = b.cloneNode(true), out = {};
    t.removeAttribute('id');
    t.removeAttribute('name');
    t.setAttribute('aria-hidden', 'true');
    t.setAttribute('tabindex', '-1');
    t.disabled = true;
    ['transition', 'animation'].forEach(function (p) { t.style.setProperty(p, 'none', 'important'); });
    t.style.setProperty('position', 'absolute', 'important');
    t.style.setProperty('left', '-10000px', 'important');
    t.style.setProperty('top', '0', 'important');
    t.style.setProperty('pointer-events', 'none', 'important');
    b.parentNode.insertBefore(t, b.nextSibling);
    var cs = window.getComputedStyle(t);
    PROPS.forEach(function (p) { out[p] = cs.getPropertyValue(p); });
    t.parentNode.removeChild(t);
    b.__gdAtcLook = out;
    return out;
  }
  function hold(b) {
    if (b.__gdAtc) return;
    var h = { saw: false, t: 0, was: {}, bare: !b.hasAttribute('style') }, mo = null, cap = 0, l;
    try { l = look(b); } catch (e) { return; }
    b.__gdAtc = h;
    PROPS.forEach(function (p) {
      h.was[p] = [b.style.getPropertyValue(p), b.style.getPropertyPriority(p)];
      b.style.setProperty(p, l[p], 'important');
    });
    b.setAttribute('data-gd-adding', '');
    function done() {
      if (b.__gdAtc !== h) return;
      b.__gdAtc = null;
      PROPS.forEach(function (p) {
        if (h.was[p][0]) b.style.setProperty(p, h.was[p][0], h.was[p][1]);
        else b.style.removeProperty(p);
      });
      if (h.bare && !b.getAttribute('style')) b.removeAttribute('style');
      b.removeAttribute('data-gd-adding');
      if (mo) mo.disconnect();
      clearTimeout(h.t);
      clearTimeout(cap);
    }
    function check() {
      if (b.classList.contains('loading')) h.saw = true;
      clearTimeout(h.t);
      if (!busy(b)) h.t = setTimeout(done, h.saw ? AFTER : GRACE);
    }
    if (window.MutationObserver) {
      mo = new MutationObserver(check);
      mo.observe(b, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
    }
    cap = setTimeout(done, CAP);
    setTimeout(check, 0);
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pdp-atc') : null;
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true' || !b.parentNode) return;
    var f = b.form || (b.closest && b.closest('form'));
    if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    hold(b);
  }, true);
})();
